import Components from '../../Components';
import { getIsManager } from '../../Core/Utils/userPermissions';
import { MANAGE_OFFICES_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: MANAGE_OFFICES_PATH,
  exact: true,
  name: 'navigation.menu.manageOffice',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isAuthorized: ({ profile }) => {
    return getIsManager(profile);
  },
};

export default RouteConfig;
